import http from '@/assets/common/http';
// ------------------------------------------采购订单管理
// ---------------------------------------------进入页面拉取数据
export function queryEntryFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 7,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------------SKU库
export function chooseEntryFun(data) {
  const params = {
    // SERVICE_ID: '10035',
    SERVICE_ID: '10008',
    OTYPE: 18,
    // 13
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 验收订单增加产品
export function chooseCheckFun(data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 22,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------新增录入订单功能
export function addOrderFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    // SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------------------------获取客户
export function haveGYSFun() {
  const params = {
    SERVICE_ID: '10001',
    // OTYPE: 1,
    OTYPE: 9,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// ----------------------------------------------------删除订单产品
export function deleteOrderFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 8,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------------------复制订单产品
export function copyOrderFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 15,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------------------导出全部订单产品
export function exportOrderFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 10,
    // GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
export function exportOrderDetail(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 14,
    // GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------------------导入采购商品
export function exportAll(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 13,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------------------验收订单产品
export function checkOrderFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 11,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------------------增加产品功能
export function addOrderListFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 2,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------------------录入完成功能
export function finishFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 3,
    // SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------------------查询采购订单详情功能
export function queryOrderDetailFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 4,
    // SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -----------------------------------------------------获取整单备注
export function getReMark(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 52,
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------------------删除采购订单详情产品
export function deleteOrderDetailFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 5,
    // SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------------------修改采购订单产品
export function updateOrderFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 6,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------------------采购订单历史订单
export function historyOrderFun(data) {
  const params = {
    SERVICE_ID: '10034',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------------------采购订单历史订单详情
export function historyOrderDetailFun(data) {
  const params = {
    SERVICE_ID: '10034',
    OTYPE: 2,
    // GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------------------新采购订单历史订单详情
export function newHistoryOrderDetailFun(data) {
  const params = {
    SERVICE_ID: '10179',
    OTYPE: 14,
    // GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------------------导出历史订单
export function exportHistoryFun(data) {
  const params = {
    SERVICE_ID: '10034',
    OTYPE: 3,
    // GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------------------导出全部历史订单
export function exportHistoryAllFun(data) {
  const params = {
    SERVICE_ID: '10034',
    OTYPE: 4,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------------------一键转换供应商
export function oneGYSFun() {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    // ...data
  };
  return http.post(params);
}
// --------------------------------------------项目点数据
export function selectProjectFun(data) {
  const params = {
    SERVICE_ID: '10006',
    OTYPE: 4,
    // SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------------档口数据
export function selectDKFun(data) {
  const params = {
    SERVICE_ID: '10007',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------------一键转换确定按钮
export function oneSubmitFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 12,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取切换供应商
export function querySupplierFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 16,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 切换移动商品模态框
export function copyProductFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 17,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
    ...data,
  };
  return http.post(params);
}
// 获取拆分数据
export function querySperateFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 18,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 确认拆分
export function submitSperateFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 19,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 待送订单（导入）
export function orderExport(data) {
  const params = {
    SERVICE_ID: '10003',
    // OTYPE: 20,
    OTYPE: 25,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导入订单按总价导入
export function feeOrderExport(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 24,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 短打印点击打印增加次数
export function addPriceCount(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 26,
    ...data,
  };
  return http.post(params);
}
// 获取学校
export function haveCKSFun() {
  const params = {
    SERVICE_ID: '10001',
    // OTYPE: 1,
    OTYPE: 9,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// 采购待送订单导出
export function exportNewOrdeFun(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 1,
    ...data,
  };
  return http.post(params);
}
// 采购单导出
export function exportSingleDocFunc(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 2,
    ...data,
  };
  return http.post(params);
}
// 采购品检测报告
export function uploadBatch(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 下载采购品检测报告
export function downloadBatchReport(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 19,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取待确认订单
export function getConfirmOrderFun(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出全部待确认订单
export function exportConfirmAllFun(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 验收订单
export function checkConfirmOrderFun(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 7,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 转待确认
export function changeConfirm(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 供应商确认订单
export function supplierCondirmOrderFun(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 9,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 单个订单修改实收
export function modifyOrderFun(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 10,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 历史价格更新
export function updateHistoryPrice(data) {
  const params = {
    SERVICE_ID: '10034',
    OTYPE: 8,
    ...data,
  };
  return http.post(params);
}
// 订单批量修改实收
export function modifyAllOrderFun(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 11,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 查询采购订单
export function searchShopFun(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 12,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出查询的采购订单
export function exportShopFun(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 13,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 待送订单详情批量修改
export function batchEdit(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 51,
    ...data,
  };
  return http.post(params);
}
// 采购单批量上传批次报告
export function batchUploadBatchReport(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 18,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/shopOrderManage.js